
import React from "react";
import SignIn from "../components/SignIn";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: "100%",
//     minHeight: "100vh",
//     },
//   //create custom keyword for class styling 
// }));
function Home() {
  
  return (
    <div>
      <SignIn></SignIn>
    </div>
  );
}

export default Home;
